import React, { useEffect, useState } from "react";
import Select from 'react-select';
import '../../../assets/styles/Styles.css'
import { OneKlicksFileSDK } from "../../../SDK/OneKlicksFileSDK";
import ImageShow from "../../../Uitiles/ImageShow";

const PersonalDetails = ({PersonalDetailsformdata, setPersonalDetailsFormdata}) => {

    const [selectedlanguages, setSelectedLanguages] = useState([]);
    const [errors, setErrors] = useState({});

    // const [formdata, setPersonalDetailsFormdata] = useState({
    //     name: "",
    //     gendar: "",
    //     subheading: "",
    //     first_name: "",
    //     last_name: "",
    //     display_name: "",
    //     starting_price: "",
    //     mobile_number: "",
    //     description: "",
    //     languages: [],
    //     profile_photo: null,
    //     memberships: [],
    // });

    const [previewImage, setPreviewImage] = useState(null);
    const [previewBanner, setPreviewBanner] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [isBannerUploading, setIsBannerUploading] = useState(false);

    const [newMembership, setNewMembership] = useState("");
    const [editingMembership, setEditingMembership] = useState(null);

    const validateField = (name, value) => {
        let error = '';
        switch (name) {
            case 'gendar':
                if (!value) error = 'Gender is required';
                break;
            case 'subheading':
                if (!value) error = 'Sub heading is required';
                break;
            case 'first_name':
                if (!value) error = 'First name is required';
                else if (!/^[a-zA-Z\s]{2,50}$/.test(value)) error = 'First name should only contain letters and spaces (2-50 characters)';
                break;
            case 'last_name':
                if (!value) error = 'Last name is required';
                else if (!/^[a-zA-Z\s]{2,50}$/.test(value)) error = 'Last name should only contain letters and spaces (2-50 characters)';
                break;
            case 'display_name':
                if (!value) error = 'Display name is required';
                else if (!/^[a-zA-Z0-9\s]{2,50}$/.test(value)) error = 'Display name should only contain letters, numbers, and spaces (2-50 characters)';
                break;
            case 'starting_price':
                if (!value) error = 'Starting price is required';
                else if (isNaN(value) || value < 0) error = 'Please enter a valid price';
                break;
            case 'mobile_number':
                if (!value) error = 'Mobile number is required';
                else if (!/^\+?[1-9]\d{7,14}$/.test(value)) error = 'Please enter a valid international phone number';
                break;
            case 'description':
                if (!value) error = 'Description is required';
                break;
            case 'languages':
                if (!value || value.length === 0) error = 'At least one language is required';
                break;
            case 'profile_photo':
                if (!value) error = 'Profile photo is required';
                break;
            default:
                break;
        }
        return error;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const error = validateField(name, value);
        setErrors(prev => ({
            ...prev,
            [name]: error
        }));
        setPersonalDetailsFormdata((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleFileChange = async (e) => {
        console.log("handleFileChange", e.target.files[0]);
        const file = e.target.files[0];
        if (file) {
            const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
            if (!validTypes.includes(file.type)) {
                setErrors(prev => ({
                    ...prev,
                    profile_photo: 'Please upload a valid image file (JPEG, PNG, or GIF)'
                }));
                return;
            }

            setIsUploading(true);
            try {
                // Upload file to server
                const root = "doctors/profile";
                const status = "public";
                const uploadResult = await OneKlicksFileSDK.uploadFile(root, status, file);
                
                if (!uploadResult || !uploadResult.fileId) {
                    throw new Error('Failed to upload file');
                }

                // Set preview and update form data
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreviewImage(reader.result);
                    setPersonalDetailsFormdata(prev => ({
                        ...prev,
                        profile_photo: uploadResult.fileId,
                        profile_photo_url: `${uploadResult.file.root}/${uploadResult.file.fileName}`
                    }));
                    setErrors(prev => ({
                        ...prev,
                        profile_photo: ''
                    }));
                };
                reader.readAsDataURL(file);
            } catch (error) {
                console.error('Error uploading file:', error);
                setErrors(prev => ({
                    ...prev,
                    profile_photo: 'Failed to upload file. Please try again.'
                }));
            } finally {
                setIsUploading(false);
            }
        }
    };

    const handleRemoveImage = () => {
        setPreviewImage(null);
        setPersonalDetailsFormdata(prev => ({
            ...prev,
            profile_photo: null
        }));
        setErrors(prev => ({
            ...prev,
            profile_photo: 'Profile photo is required'
        }));
    };

    const handleBannerChange = async (e) => {
        const file = e.target.files[0];

        console.log("handleBannerChange file", file);
        if (file) {
            const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
            if (!validTypes.includes(file.type)) {
                setErrors(prev => ({
                    ...prev,
                    profile_banner: 'Please upload a valid image file (JPEG, PNG, or GIF)'
                }));
                return;
            }

            setIsBannerUploading(true);
            try {
                // Upload file to server
                const root = "doctors/banner";
                const status = "public";
                const uploadResult = await OneKlicksFileSDK.uploadFile(root, status, file);
                
                if (!uploadResult || !uploadResult.fileId) {
                    throw new Error('Failed to upload file');
                }

                console.log("uploadResult new", uploadResult);

                const bannerurl = `${uploadResult.file.root}/${uploadResult.file.fileName}`;

                console.log("bannerurl", bannerurl);

                // Set preview and update form data
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreviewBanner(reader.result);
                    console.log("reader.result", reader.result);
                    console.log("uploadResult", `${uploadResult.root}/${uploadResult.fileName}`);
                    setPersonalDetailsFormdata(prev => ({
                        ...prev,
                        profile_banner: uploadResult.fileId,
                        profile_banner_url: bannerurl
                    }));
                    setErrors(prev => ({
                        ...prev,
                        profile_banner: ''
                    }));
                };
                reader.readAsDataURL(file);
            } catch (error) {
                console.error('Error uploading banner:', error);
                setErrors(prev => ({
                    ...prev,
                    profile_banner: 'Failed to upload file. Please try again.'
                }));
            } finally {
                setIsBannerUploading(false);
            }
        }
    };

    const handleRemoveBanner = () => {
        setPreviewBanner(null);
        setPersonalDetailsFormdata(prev => ({
            ...prev,
            profile_banner: null
        }));
        setErrors(prev => ({
            ...prev,
            profile_banner: 'Profile banner is required'
        }));
    };

    const handleAddMembership = () => {
        if (newMembership.trim()) {
            const membership = {
                id: Date.now(),
                name: newMembership.trim()
            };
            setPersonalDetailsFormdata(prev => ({
                ...prev,
                memberships: [...prev.memberships, membership]
            }));
            setNewMembership("");
        }
    };

    const handleEditMembership = (id) => {
        const membership = PersonalDetailsformdata.memberships.find(m => m.id === id);
        if (membership) {
            setEditingMembership(id);
            setNewMembership(membership.name);
        }
    };

    const handleUpdateMembership = () => {
        if (editingMembership && newMembership.trim()) {
            setPersonalDetailsFormdata(prev => ({
                ...prev,
                memberships: prev.memberships.map(m => 
                    m.id === editingMembership 
                        ? { ...m, name: newMembership.trim() }
                        : m
                )
            }));
            setEditingMembership(null);
            setNewMembership("");
        }
    };

    const handleDeleteMembership = (id) => {
        setPersonalDetailsFormdata(prev => ({
            ...prev,
            memberships: prev.memberships.filter(m => m.id !== id)
        }));
    };

    const handleMembershipKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (editingMembership) {
                handleUpdateMembership();
            } else {
                handleAddMembership();
            }
        }
    };

    const styles = {
        selectedLanguages: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '8px',
            marginBottom: '10px'
        },
        selectedLanguageItem: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#f0f0f0',
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '14px'
        },
        removeButton: {
            border: 'none',
            background: 'none',
            marginLeft: '8px',
            cursor: 'pointer',
            fontSize: '16px',
            color: '#666',
            padding: '0 4px'
        }
    };

    const languages = [
        { value: "Afar", label: "Afar" },
        { value: "Abkhazian", label: "Abkhazian" },
        { value: "Avestan", label: "Avestan" },
        { value: "Afrikaans", label: "Afrikaans" },
        { value: "Akan", label: "Akan" },
        { value: "Amharic", label: "Amharic" }, 
        { value: "Aragonese", label: "Aragonese" },
        { value: "Arabic", label: "Arabic" },
        { value: "Assamese", label: "Assamese" },
        { value: "Avaric", label: "Avaric" },
        { value: "Aymara", label: "Aymara" },
        { value: "Azerbaijani", label: "Azerbaijani" },
        { value: "Bashkir", label: "Bashkir" },
        { value: "Belarusian", label: "Belarusian" },
        { value: "Bulgarian", label: "Bulgarian" },
        { value: "Bihari languages", label: "Bihari languages" },
        { value: "Bislama", label: "Bislama" },
        { value: "Bambara", label: "Bambara" },
        { value: "Bengali", label: "Bengali" },
        { value: "Tibetan", label: "Tibetan" },
        { value: "Breton", label: "Breton" },
        { value: "Bosnian", label: "Bosnian" },
        { value: "Catalan, Valencian", label: "Catalan, Valencian" },
        { value: "Chechen", label: "Chechen" },
        { value: "Chamorro", label: "Chamorro" },
        { value: "Corsican", label: "Corsican" },
        { value: "Cree", label: "Cree" },
        { value: "Czech", label: "Czech" },
        { value: "Catalan, Catalunya", label: "Catalan, Catalunya" },
        { value: "Church Slavonic, Old Bulgarian, Old Church Slavonic", label: "Church Slavonic, Old Bulgarian, Old Church Slavonic" },
        { value: "Chuvash", label: "Chuvash" },
        { value: "Welsh", label: "Welsh" },
        { value: "Danish", label: "Danish" },
        { value: "German", label: "German" },
        { value: "Divehi, Dhivehi, Maldivian", label: "Divehi, Dhivehi, Maldivian" },
        { value: "Dzongkha", label: "Dzongkha" },
        { value: "Ewe", label: "Ewe" },
        { value: "Greek (Modern)", label: "Greek (Modern)" },
        { value: "English", label: "English" },
        { value: "Esperanto", label: "Esperanto" },
        { value: "Spanish, Castilian", label: "Spanish, Castilian" },
        { value: "Estonian", label: "Estonian" },
        { value: "Basque", label: "Basque" },
        { value: "Persian", label: "Persian" },
        { value: "Fulah", label: "Fulah" },
        { value: "Finnish", label: "Finnish" },
        { value: "Fijian", label: "Fijian" },
        { value: "Faroese", label: "Faroese" },
        { value: "French", label: "French" },
        { value: "Western Frisian", label: "Western Frisian" },
        { value: "Irish", label: "Irish" },
        { value: "Gaelic, Scottish Gaelic", label: "Gaelic, Scottish Gaelic" },
        { value: "Galician", label: "Galician" },
        { value: "Guarani", label: "Guarani" },
        { value: "Gujarati", label: "Gujarati" },
        { value: "Manx", label: "Manx" },
        { value: "Hausa", label: "Hausa" },
        { value: "Hebrew", label: "Hebrew" },
        { value: "Hindi", label: "Hindi" },
        { value: "Hiri Motu", label: "Hiri Motu" },
        { value: "Croatian", label: "Croatian" },
        { value: "Haitian, Haitian Creole", label: "Haitian, Haitian Creole" },
        { value: "Hungarian", label: "Hungarian" },
        { value: "Armenian", label: "Armenian" },
        { value: "Herero", label: "Herero" },
        { value: "Interlingua (International Auxiliary Language Association)", label: "Interlingua (International Auxiliary Language Association)" },
        { value: "Indonesian", label: "Indonesian" },
        { value: "Interlingue", label: "Interlingue" },
        { value: "Igbo", label: "Igbo" },
        { value: "Nuosu, Sichuan Yi", label: "Nuosu, Sichuan Yi" },
        { value: "Inupiaq", label: "Inupiaq" },
        { value: "Ido", label: "Ido" },
        { value: "Icelandic", label: "Icelandic" },
        { value: "Italian", label: "Italian" },
        { value: "Inuktitut", label: "Inuktitut" },
        { value: "Japanese", label: "Japanese" },
        { value: "Javanese", label: "Javanese" },
        { value: "Georgian", label: "Georgian" },
        { value: "Kongo", label: "Kongo" },
        { value: "Gikuyu, Kikuyu", label: "Gikuyu, Kikuyu" },
        { value: "Kwanyama, Kuanyama", label: "Kwanyama, Kuanyama" },
        { value: "Kazakh", label: "Kazakh" },
        { value: "Greenlandic, Kalaallisut", label: "Greenlandic, Kalaallisut" },
        { value: "Central Khmer", label: "Central Khmer" },
        { value: "Kannada", label: "Kannada" },
        { value: "Korean", label: "Korean" },
        { value: "Kanuri", label: "Kanuri" },
        { value: "Kashmiri", label: "Kashmiri" },
        { value: "Kurdish", label: "Kurdish" },
        { value: "Komi", label: "Komi" },
        { value: "Cornish", label: "Cornish" },
        { value: "Kyrgyz", label: "Kyrgyz" },
        { value: "Latin", label: "Latin" },
        { value: "Letzeburgesch, Luxembourgish", label: "Letzeburgesch, Luxembourgish" },
        { value: "Ganda", label: "Ganda" },
        { value: "Limburgish, Limburgan, Limburger", label: "Limburgish, Limburgan, Limburger" },
        { value: "Lingala", label: "Lingala" },
        { value: "Lao", label: "Lao" },
        { value: "Lithuanian", label: "Lithuanian" },
        { value: "Luba-Katanga", label: "Luba-Katanga" },
        { value: "Latvian", label: "Latvian" },
        { value: "Malagasy", label: "Malagasy" },
        { value: "Marshallese", label: "Marshallese" },
        { value: "Maori", label: "Maori" },
        { value: "Macedonian", label: "Macedonian" },
        { value: "Malayalam", label: "Malayalam" },
        { value: "Mongolian", label: "Mongolian" },
        { value: "Marathi", label: "Marathi" },
        { value: "Malay", label: "Malay" },
        { value: "Maltese", label: "Maltese" },
        { value: "Burmese", label: "Burmese" },
        { value: "Nauru", label: "Nauru" },
        { value: "Norwegian Bokmål", label: "Norwegian Bokmål" },
        { value: "Northern Ndebele", label: "Northern Ndebele" },
        { value: "Nepali", label: "Nepali" },
        { value: "Ndonga", label: "Ndonga" },
        { value: "Dutch, Flemish", label: "Dutch, Flemish" },
        { value: "Norwegian Nynorsk", label: "Norwegian Nynorsk" },
        { value: "Norwegian", label: "Norwegian" },
        { value: "South Ndebele", label: "South Ndebele" },
        { value: "Navajo, Navaho", label: "Navajo, Navaho" },
        { value: "Chichewa, Chewa, Nyanja", label: "Chichewa, Chewa, Nyanja" },
        { value: "Occitan (post 1500)", label: "Occitan (post 1500)" },
        { value: "Ojibwa", label: "Ojibwa" },
        { value: "Oromo", label: "Oromo" },
        { value: "Oriya", label: "Oriya" },
        { value: "Ossetian, Ossetic", label: "Ossetian, Ossetic" },
        { value: "Panjabi, Punjabi", label: "Panjabi, Punjabi" },
        { value: "Pali", label: "Pali" },
        { value: "Polish", label: "Polish" },
        { value: "Pashto, Pushto", label: "Pashto, Pushto" },
        { value: "Portuguese", label: "Portuguese" },
        { value: "Quechua", label: "Quechua" },
        { value: "Romansh", label: "Romansh" },
        { value: "Rundi", label: "Rundi" },
        { value: "Moldovan, Moldavian, Romanian", label: "Moldovan, Moldavian, Romanian" },
        { value: "Russian", label: "Russian" },
        { value: "Kinyarwanda", label: "Kinyarwanda" },
        { value: "Sanskrit", label: "Sanskrit" },
        { value: "Sardinian", label: "Sardinian" },
        { value: "Sindhi", label: "Sindhi" },
        { value: "Northern Sami", label: "Northern Sami" },
        { value: "Sango", label: "Sango" },
        { value: "Sinhala, Sinhalese", label: "Sinhala, Sinhalese" },
        { value: "Slovak", label: "Slovak" },
        { value: "Slovenian", label: "Slovenian" },
        { value: "Samoan", label: "Samoan" },
        { value: "Shona", label: "Shona" },
        { value: "Somali", label: "Somali" },
        { value: "Albanian", label: "Albanian" },
        { value: "Serbian", label: "Serbian" },
        { value: "Swati", label: "Swati" },
        { value: "Sotho, Southern", label: "Sotho, Southern" },
        { value: "Sundanese", label: "Sundanese" },
        { value: "Swedish", label: "Swedish" },
        { value: "Swahili", label: "Swahili" },
        { value: "Tamil", label: "Tamil" },
        { value: "Telugu", label: "Telugu" },
        { value: "Tajik", label: "Tajik" },
        { value: "Thai", label: "Thai" },
        { value: "Tigrinya", label: "Tigrinya" },
        { value: "Turkmen", label: "Turkmen" },
        { value: "Tagalog", label: "Tagalog" },
        { value: "Tswana", label: "Tswana" },
        { value: "Tonga (Tonga Islands)", label: "Tonga (Tonga Islands)" },
        { value: "Turkish", label: "Turkish" },
        { value: "Tsonga", label: "Tsonga" },
        { value: "Tatar", label: "Tatar" },
        { value: "Twi", label: "Twi" },
        { value: "Tahitian", label: "Tahitian" },   
        { value: "Uighur, Uyghur", label: "Uighur, Uyghur" },
        { value: "Ukrainian", label: "Ukrainian" },
        { value: "Urdu", label: "Urdu" },
        { value: "Uzbek", label: "Uzbek" },
        { value: "Venda", label: "Venda" },
        { value: "Vietnamese", label: "Vietnamese" },
        { value: "Volap_k", label: "Volap_k" },
        { value: "Walloon", label: "Walloon" },
        { value: "Wolof", label: "Wolof" },
        { value: "Xhosa", label: "Xhosa" },
        { value: "Yiddish", label: "Yiddish" },
        { value: "Yoruba", label: "Yoruba" },
        { value: "Zhuang, Chuang", label: "Zhuang, Chuang" },
        { value: "Chinese", label: "Chinese" },
        { value: "Zulu", label: "Zulu" }
    ];

    useEffect(() => {
        const loadProfilePhoto = async () => {
            const profilephoto = PersonalDetailsformdata.profile_photo_url;
            const profilebanner = PersonalDetailsformdata.profile_banner_url;
            
            if (profilephoto) {
                try {
                    console.log("profilephoto", profilephoto);
                    setPreviewImage(profilephoto);
                } catch (error) {
                    console.error('Error loading profile photo:', error);
                }
            }
            
            if (profilebanner) {
                try {
                    console.log("profilebanner", profilebanner);
                    setPreviewBanner(profilebanner);
                } catch (error) {
                    console.error('Error loading profile banner:', error);
                }
            }
        };

        loadProfilePhoto();
    }, [PersonalDetailsformdata.profile_photo, PersonalDetailsformdata.profile_banner]);

    useEffect(() => {
        if (PersonalDetailsformdata.languages?.length > 0 && !selectedlanguages.length) {
            const defaultSelected = languages.filter(option => 
                PersonalDetailsformdata.languages.includes(option.value)
            );
            setSelectedLanguages(defaultSelected);
        }
    }, [PersonalDetailsformdata.languages]);

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-personalskillshold tab-pane active fade show" id="dc-skills">
                <div className="dc-yourdetails dc-tabsinfo">
                    <div className="dc-tabscontenttitle">
                        <h3>Your Details</h3>
                    </div>
                    <div className="dc-formtheme dc-userform">
                        <fieldset>
                            <div className="form-group form-group-half">
                                <span className="dc-select">
                                    <select 
                                        name="gendar" 
                                        onChange={handleChange} 
                                        className={`form-control ${errors.gendar ? 'is-invalid' : ''}`} 
                                        value={PersonalDetailsformdata.gendar} 
                                        style={{ height: '50px' }}
                                    >
                                        <option value="">Select gender</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                        <option value="all">Others</option>
                                    </select>
                                    {errors.gendar && <div className="invalid-feedback">{errors.gendar}</div>}
                                </span>
                            </div>
                            <div className="form-group form-group-half toolip-wrapo">
                                <input 
                                    type="text" 
                                    value={PersonalDetailsformdata.subheading} 
                                    name="subheading" 
                                    className={`form-control ${errors.subheading ? 'is-invalid' : ''}`}
                                    placeholder="Sub Heading" 
                                    onChange={handleChange} 
                                />
                                {errors.subheading && <div className="invalid-feedback">{errors.subheading}</div>}
                            </div>
                            <div className="form-group form-group-half toolip-wrapo">
                                <input 
                                    type="text" 
                                    name="first_name" 
                                    className={`form-control ${errors.first_name ? 'is-invalid' : ''}`}
                                    value={PersonalDetailsformdata.first_name} 
                                    placeholder="First name" 
                                    onChange={handleChange} 
                                />
                                {errors.first_name && <div className="invalid-feedback">{errors.first_name}</div>}
                            </div>
                            <div className="form-group form-group-half toolip-wrapo">
                                <input 
                                    type="text" 
                                    value={PersonalDetailsformdata.last_name} 
                                    onChange={handleChange} 
                                    name="last_name" 
                                    className={`form-control ${errors.last_name ? 'is-invalid' : ''}`}
                                    placeholder="Last Name" 
                                />
                                {errors.last_name && <div className="invalid-feedback">{errors.last_name}</div>}
                            </div>
                            <div className="form-group toolip-wrapo">
                                <input 
                                    type="text" 
                                    name="display_name" 
                                    className={`form-control ${errors.display_name ? 'is-invalid' : ''}`}
                                    value={PersonalDetailsformdata.display_name} 
                                    placeholder="Display name" 
                                    onChange={handleChange} 
                                />
                                {errors.display_name && <div className="invalid-feedback">{errors.display_name}</div>}
                            </div>
                            <div className="form-group form-group-half toolip-wrapo">
                                <input 
                                    type="number" 
                                    name="starting_price" 
                                    className={`form-control ${errors.starting_price ? 'is-invalid' : ''}`}
                                    value={PersonalDetailsformdata.starting_price} 
                                    placeholder="Starting Price" 
                                    onChange={handleChange} 
                                />
                                {errors.starting_price && <div className="invalid-feedback">{errors.starting_price}</div>}
                            </div>
                            <div className="form-group toolip-wrapo">
                                <input 
                                    type="text" 
                                    name="mobile_number" 
                                    className={`form-control ${errors.mobile_number ? 'is-invalid' : ''}`}
                                    value={PersonalDetailsformdata.mobile_number} 
                                    placeholder="Personal mobile number" 
                                    onChange={handleChange} 
                                />
                                {errors.mobile_number && <div className="invalid-feedback">{errors.mobile_number}</div>}
                            </div>
                            <div className="form-group">
                                <textarea 
                                    name="description" 
                                    value={PersonalDetailsformdata.description} 
                                    onChange={handleChange} 
                                    className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                                    placeholder="Description"
                                ></textarea>
                                {errors.description && <div className="invalid-feedback">{errors.description}</div>}
                            </div>
                        </fieldset>
                    </div>
                </div>
                <div className="dc-tabsinfo">
                    <div className="dc-tabscontenttitle">
                        <h3>Select languages</h3>
                    </div>
                    <div className="dc-settingscontent dc-sidepadding">
                        <div className="dc-formtheme dc-userform">
                            <div className="form-group">
                                <Select
                                    name="settings[languages][]"
                                    options={languages}
                                    placeholder="Select languages"
                                    className={`am_gender ${errors.languages ? 'is-invalid' : ''}`}
                                    isMulti
                                    value={selectedlanguages || []}
                                    onChange={(selectedOptions) => {
                                        const updated = selectedOptions || [];
                                        setSelectedLanguages(updated);
                                        const error = validateField('languages', updated);
                                        setErrors(prev => ({
                                            ...prev,
                                            languages: error
                                        }));
                                        setPersonalDetailsFormdata((prevData) => ({
                                            ...prevData,
                                            languages: updated.map(option => option.value),
                                        }));
                                    }}
                                    isSearchable
                                />
                                {errors.languages && <div className="invalid-feedback">{errors.languages}</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dc-profilephoto dc-tabsinfo">
                    <div className="dc-tabscontenttitle">
                        <h3>Hospital Logo</h3>
                    </div>
                    <div className="dc-profilephotocontent">
                        <div className="dc-formtheme dc-formprojectinfo dc-formcategory" id="dc-img-9880">
                            <fieldset>
                                <div className="form-group form-group-label" id="dc-image-container-9880" style={{ position: 'relative' }}>
                                    <div className="dc-labelgroup" id="image-drag-9880" style={{ position: 'relative' }}>
                                        <label htmlFor="profile-photo" className="dc-image-file">
                                            <span className={`ajax-load dc-btn ${errors.profile_photo ? 'is-invalid' : ''}`} id="image-btn-9880">Select File</span>
                                        </label>
                                        <span>Drop files here to upload</span>
                                        {isUploading && (
                                            <em className="dc-fileuploading">
                                                Uploading<i className="fa fa-spinner fa-spin"></i>
                                            </em>
                                        )}
                                    </div>
                                    <div className="moxie-shim moxie-shim-html5" style={{ position: 'absolute', top: 7, left: 11, width: 160, height: 42, overflow: 'hidden', zIndex: 0 }}>
                                        <input
                                            id="profile-photo"
                                            type="file"
                                            style={{ fontSize: 999, opacity: 0, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                            accept="image/jpeg,.jpg,.jpeg,image/gif,.gif,image/png,.png"
                                            onChange={handleFileChange}
                                        />
                                    </div>
                                    {errors.profile_photo && <div className="invalid-feedback">{errors.profile_photo}</div>}
                                </div>
                                {previewImage && (
                                    <div className="form-group uploaded-placeholder">
                                        <ul className="dc-attachfile dc-attachfilevtwo">
                                            <li className="dc-uploadingholder dc-companyimg-user">
                                                <div className="dc-uploadingbox">
                                                    <figure key={PersonalDetailsformdata.profile_photo_url}>
                                                        <ImageShow url={PersonalDetailsformdata.profile_photo_url}  />
                                                    </figure>
                                                    <div className="dc-uploadingbar">
                                                        <span className="uploadprogressbar"></span>
                                                        <span>{PersonalDetailsformdata.profile_photo?.name}</span>
                                                        <em>
                                                            File size: {(PersonalDetailsformdata.profile_photo?.size / 1024).toFixed(2)} KB
                                                            <a
                                                                href="#"
                                                                className="dc-remove-image lnr lnr-cross"
                                                                onClick={handleRemoveImage}
                                                            ></a>
                                                        </em>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                </div>

                <div className="dc-profilephoto dc-tabsinfo">
                    <div className="dc-tabscontenttitle">
                        <h3>Hospital Banner</h3>
                    </div>
                    <div className="dc-profilephotocontent">
                        <div className="dc-formtheme dc-formprojectinfo dc-formcategory" id="dc-img-9881">
                            <fieldset>
                                <div className="form-group form-group-label" id="dc-image-container-9881" style={{ position: 'relative' }}>
                                    <div className="dc-labelgroup" id="image-drag-9881" style={{ position: 'relative' }}>
                                        <label htmlFor="profile-banner" className="dc-image-file">
                                            <span className={`ajax-load dc-btn ${errors.profile_banner ? 'is-invalid' : ''}`} id="image-btn-9881">Select File</span>
                                        </label>
                                        <span>Drop files here to upload</span>
                                        {isBannerUploading && (
                                            <em className="dc-fileuploading">
                                                Uploading<i className="fa fa-spinner fa-spin"></i>
                                            </em>
                                        )}
                                    </div>
                                    <div className="moxie-shim moxie-shim-html5" style={{ position: 'absolute', top: 7, left: 11, width: 160, height: 42, overflow: 'hidden', zIndex: 0 }}>
                                        <input
                                            id="profile-banner"
                                            type="file"
                                            style={{ fontSize: 999, opacity: 0, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                            accept="image/jpeg,.jpg,.jpeg,image/gif,.gif,image/png,.png"
                                            onChange={handleBannerChange}
                                        />
                                    </div>
                                    {errors.profile_banner && <div className="invalid-feedback">{errors.profile_banner}</div>}
                                </div>
                                {previewBanner && (
                                    <div className="form-group uploaded-placeholder">
                                        <ul className="dc-attachfile dc-attachfilevtwo">
                                            <li className="dc-uploadingholder dc-companyimg-user">
                                                <div className="dc-uploadingbox">
                                                    <figure>
                                                        <img className="img-thumb" src={`${process.env.REACT_APP_MODE === 'LIVE' ? process.env.REACT_APP_API_BASE_LIVE_URL : process.env.REACT_APP_API_BASE_URL}${previewBanner}`} alt="Banner Preview" />
                                                    </figure>
                                                    <div className="dc-uploadingbar">
                                                        <span className="uploadprogressbar"></span>
                                                        <span>{PersonalDetailsformdata.profile_banner?.name}</span>
                                                        <em>
                                                            File size: {(PersonalDetailsformdata.profile_banner?.size / 1024).toFixed(2)} KB
                                                            <a
                                                                href="#"
                                                                className="dc-remove-image lnr lnr-cross"
                                                                onClick={handleRemoveBanner}
                                                            ></a>
                                                        </em>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                </div>
                <div className="dc-skills dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle">
                        <h3>Memberships</h3>
                    </div>
                    <div className="dc-skillscontent-holder">
                        <div className="dc-formtheme dc-skillsform">
                            <fieldset>
                                <div className="form-group">
                                    <div className="form-group-holder">
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your Memberships" 
                                            value={newMembership}
                                            onChange={(e) => setNewMembership(e.target.value)}
                                            onKeyPress={handleMembershipKeyPress}
                                        />
                                    </div>
                                </div>
                                <div className="form-group dc-btnarea">
                                    <a 
                                        className="dc-btn"
                                        onClick={editingMembership ? handleUpdateMembership : handleAddMembership}
                                    >
                                        {editingMembership ? 'Update' : 'Add Now'}
                                    </a>
                                </div>
                            </fieldset>
                        </div>
                        <div className="dc-myskills">
                            <ul className="sortable list dc-memberships dc-sortable-list ui-sortable">
                                {PersonalDetailsformdata.memberships && PersonalDetailsformdata.memberships.length > 0 ? (
                                    PersonalDetailsformdata.memberships.map((membership) => (
                                        <li key={membership.id}>
                                            <div className="dc-dragdroptool">
                                            <a href="javascript:" className="lnr lnr-menu"></a>
                                        </div>
                                        <span className="skill-dynamic-html">
                                            <em className="skill-val">{membership.name}</em>
                                        </span>
                                        <span className="skill-dynamic-field">
                                            <input 
                                                type="text" 
                                                name={`memberships[${membership.id}]`} 
                                                value={membership.name} 
                                                readOnly 
                                            />
                                        </span>
                                        <div className="dc-rightarea">
                                            <a 
                                                href="#" 
                                                className="dc-addinfo"
                                                onClick={() => handleEditMembership(membership.id)}
                                            >
                                                <i className="lnr lnr-pencil"></i>
                                            </a>
                                            <a 
                                                href="#" 
                                                className="dc-deleteinfo"
                                                onClick={() => handleDeleteMembership(membership.id)}
                                            >
                                                <i className="lnr lnr-trash"></i>
                                            </a>
                                        </div>
                                    </li>
                                ))
                                ) : (
                                    <li>No memberships added</li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PersonalDetails;
